import { FormGroupNameDirective } from 'eurogard-forms';
import { Directive, forwardRef, Inject, Input, isDevMode, NgModule, Optional, Self, SkipSelf } from '@angular/core';
import { ControlContainer, NG_ASYNC_VALIDATORS, NG_VALIDATORS } from '@angular/forms';
import { FormTableDataSourceDirective } from '../form-table-data-source.directive';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[rxapFormGroupRow]',
  providers: [
    {
      provide: ControlContainer,
      useExisting: forwardRef(() => FormGroupRowDirective),
    },
  ],
  standalone: true,
})
export class FormGroupRowDirective extends FormGroupNameDirective {

  constructor(
    @SkipSelf()
    @Inject(ControlContainer)
    private readonly parent: ControlContainer,
    private readonly formTableDataSourceDirective: FormTableDataSourceDirective,
    @Optional() @Self() @Inject(NG_VALIDATORS) validators: any[],
    @Optional() @Self() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: any[],
  ) {
    super(parent, validators, asyncValidators);
  }

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('rxapFormGroupRow')
  public set dataIndex(value: number) {
    let offset = 0;
    const paginator = this.formTableDataSourceDirective.paginator;
    if (paginator) {
      offset = paginator.pageIndex * paginator.pageSize;
    }
    this.name = value + offset;
    if (isDevMode()) {
      console.log('load name ' + this.name);
    }
  }

}


